<template>
  <div class="order">
    <div class="header">
      <div class="w clearfix">
        <div class="logo" @click="goIndex()">
          <img class="sy_logo" :src="logoUlr" />
        </div>
        <div class="msg">确认订单信息</div>
      </div>
    </div>
    <div id="content" class="w" style="width: 1510px;">
      <div class="checkout-steps">
        <div class="w" style="width: 1510px;">
          <strong class="orderInfo">订单信息</strong>
          <table
            width="100%"
            border="1"
            cellpadding="0"
            cellspacing="0"
            style="table-layout:fixed;"
          >
            <thead>
              <th width="38">序号</th>
              <th width="88">第三方单号</th>
              <th width="88">合拼单号</th>
              <th width="130">规格</th>
              <th width="235">文件</th>
              <th width="98">数量*款数</th>
              <th width="78">价格</th>

               <th width="78">包装费</th>
               <th width="100">优惠金额</th>
              <th width="48">重量</th>
              <th width="88">物流方式</th>
              <th width="78">运费</th>
              <th width="78">小计</th>
              <th width="78">操作</th>
            </thead>
            <tbody v-for="(item,index) in orderList" :key="item[0].id">
              <!-- 拆包布局 -->
              <template v-if="item.length==1">
                <tr class="one">
                  <td rowspan="2" width="68">{{index+1}}</td>
                  <td style="white-space:normal;word-break:break-all;">
                    <template v-if="item[0].otherno!==null">{{item[0].otherno}}</template>
                  </td>
                   <td width="88">{{item[0].hepin_sn}}</td>
                  <td width="198">{{item[0].title}}</td>
                  <td width="208" style="word-wrap:break-word">{{item[0].file}}</td>
                  <td width="98">{{item[0].number}}{{item[0].product_unit}}X{{item[0].kuanshu}}款</td>
                  <td width="68" class="co-red">￥{{item[0].goods_price+item[0].craft_price}}元</td>
                   <td width="68" class="co-red">￥{{item[0].packprice}}元</td>
                  <td width="68" class="co-red">
                    <template v-if="product_discount_arr[item[0].product_id] == 100">无折扣</template>
                      <template v-if="product_discount_arr[item[0].product_id] < 100">
                      {{product_discount_arr[item[0].product_id]}}折优惠
                      -￥{{((parseFloat(item[0].goods_price)+parseFloat(item[0].craft_price)+parseFloat(item[0].packprice))*(100-product_discount_arr[item[0].product_id])/100).toFixed(2)}}元

                      </template>
                  </td>

                  <td width="58">{{item[0].product_weight}}kg</td>

                  <td width="88">

                    <select
                    v-model="item[0].express_id"
                      :name="'express'+index"
                      :id="'express'+item[0].id"
                      class="kuaidiSelect"
                      @change="addressChange($event,item[0].id,item[0].address_id);"
                    >
                      <template v-for="(item2,index) in item[0].expressList">
                        <option
                          v-if="item2.id==item[0].express_id"

                          :value="item2.id"
                          :key="item2.id"
                          selected
                        >{{item2.express_name}}</option>
                        <option v-else :value="item2.id" :key="index">{{item2.express_name}}</option>
                      </template>
                    </select>
                  </td>
                  <td width="68" class="co-red">￥{{item[0].realy_ship_price}}元</td>

                  <td width="68" class="co-red">
                    小计￥{{ (parseFloat(item[0].total_price) + parseFloat(item[0].realy_ship_price) + parseFloat(item[0].packprice)-((item[0].goods_price+item[0].craft_price)*(100-product_discount_arr[item[0].product_id])/100)).toFixed(2) }}元
                    </td>
                  <td rowspan="4" style="width:98px">
                    <div>
                      <el-button
                        type="info"
                        class="delete"
                        size="mini"
                        @click="delShopCar(item[0].id)"
                      >删除</el-button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="10" class="address clearfix">
                    {{'地址:'+ item[0].address_text}} {{item[0].address_query}} {{item[0].shopping_name}} {{item[0].shopping_phone}}
                    {{item[0].ext_number?'转'+item[0].ext_number:''}}
                    <button
                      class="addressSettings"
                      @click="showDialog(item[0].address_id,item[0].id,$event)"
                    >地址管理</button>
                  </td>
                </tr>
                <tr>
                  <td colspan="11" style="padding:0;height:10px;background-color:#fafafa"></td>
                </tr>
              </template>

              <!-- 合包布局 -->
              <template v-else>
                <!-- <template v-if="item[1]"> -->
                <template v-for="(item1,index1) in item">
                  <tr v-if="index1==0" class="one">
                    <td :rowspan="item.length+1">{{index+1}}</td>
                    <td :rowspan="item.length" style="white-space:normal;word-break:break-all;">
                      <template v-if="item1.otherno!==null">{{item1.otherno}}</template>
                    </td>
                    <td width="88">{{item1.hepin_sn}} </td>
                    <td>{{item1.title}}</td>
                    <td style="word-wrap:break-word">{{item1.file}}</td>
                    <td>{{item1.number}}{{item1.product_unit}}X{{item1.kuanshu}}款</td>
                    <td class="co-red">￥{{item1.total_price}}元</td>
                    <td class="co-red">￥{{item1.packprice}}元</td>

                    <td class="co-red">
                      <template v-if="product_discount_arr[item1.product_id] == 100">无折扣</template>
                      <template v-if="product_discount_arr[item1.product_id] < 100">{{product_discount_arr[item1.product_id]}}折
                      优惠
                      -￥{{(item1.total_price*(100-product_discount_arr[item1.product_id])/100).toFixed(2)}}元
                      </template>
                    </td>

                    <td :rowspan="item.length">
                      <h2>总计:</h2>
                      {{item1.total_weight}}kg
                    </td>

                    <td :rowspan="item.length">
                      <select
                        :name="'expressHe'+index"
                        :id="'express'+index"
                        class="kuaidiSelect"
                        @change="addressChange($event,item.ids,item[0].address_id)"
                      >
                        <template v-for="(item2) in item[0].expressList">
                          <option
                            v-if="item2.id==item[0].express_id"
                            :value="item2.id"
                            :key="item2.id"
                            selected
                          >{{item2.express_name}}</option>
                          <option v-else :value="item2.id" :key="item2.id">{{item2.express_name}}</option>
                        </template>
                      </select>
                    </td>
                    <td :rowspan="item.length" class="co-red">
                      <h2>总计:</h2>
                      ￥{{item1.realy_ship_price}}元
                    </td>

                    <td :rowspan="item.length" class="co-red">
                      <h2>小计:</h2>
                      ￥{{parseFloat(item.xiaoji-((item.xiaoji-item1.realy_ship_price)*(100-product_discount_arr[item1.product_id])/100)).toFixed(2)}}元
                    </td>
                    <td :rowspan="item.length" style="width:98px">
                      <!-- <div>
                        <el-button type="success" class="Chai" size="mini">拆包</el-button>
                      </div>

                      <div>
                        <el-button type="info" class="delete" size="mini">删除</el-button>
                      </div>-->
                    </td>
                  </tr>
                  <tr v-else>
                    <td width="88">{{item1.hepin_sn}} </td>
                    <td>{{item1.title}}</td>
                    <td style="word-wrap:break-word">{{item1.filename.slice(77)}}</td>
                    <td>{{item1.number}}{{item1.product_unit}}X{{item1.kuanshu}}款</td>
                    <td class="co-red ">￥{{item1.total_price}}元</td>
                    <td class="co-red ">￥{{item1.packprice}}元</td>
                    <td class="co-red ">
                    <template v-if="product_discount_arr[item1.product_id] == 100">无折扣</template>
                    <template v-if="product_discount_arr[item1.product_id] < 100">{{product_discount_arr[item1.product_id]}}折
                    优惠
                    -￥{{(item1.total_price*(100-product_discount_arr[item1.product_id])/100).toFixed(2)}}元</template>
                   </td>

                  </tr>
                </template>

                <!-- </template> -->

                <tr>
                  <td colspan="10" class="address clearfix">
                    {{'地址:'+ item[0].address_text}} {{item[0].address_query}} {{item[0].shopping_name}} {{item[0].shopping_phone}}
                    <button
                      class="addressSettings"
                      @click="showDialog(item[0].address_id,item.ids,$event)"
                    >地址管理</button>
                  </td>
                </tr>
                <tr>
                  <td colspan="11" style="padding:0;height:10px;background-color:#fafafa"></td>
                </tr>
              </template>
            </tbody>
          </table>
          <!-- 地址管理 -->
          <el-dialog title="地址管理" :visible.sync="dialogVisible" width="50%">
            <el-button type="primary" size="small" id="addAddress" @click="addaddress()">添加地址</el-button>
            <el-input style="width:200px;margin-left:20px" size="small"  v-model="soaddress"   placeholder="输入姓名,电话,地址搜索"></el-input>
            <el-button style="margin-left:20px" size="small" type="success" @click="autoaddress">搜索</el-button>
            <div id="addressBox" style="height: 410px;overflow-y: scroll;">
              <template v-if="JSON.stringify(AddressList) !='[]'">
                <div
                  v-for="item in AddressList"
                  :id="item.id"
                  :class="item.id==currentId ? 'clearfix address-item active' : 'clearfix address-item'"
                  :key="item.id"
                >
                  <button class="un">{{item.shopping_name}}</button>

                  <p class="address1" :title="item.address">{{item.address}}</p>
                  <p class="Addressquery" :title="item.query">{{item.query}}</p>
                  <p class="AddressPhone">{{item.shopping_phone}}</p>
                  <p class="ext_number" v-show="item.ext_number">转{{item.ext_number}}</p>
                  <div class="caozuo" v-if="item.def==0">
                     <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
                    <span style="margin-left: 10px;" class="set" @click="settingAddress(item.id)">设置默认</span>
                    <a class="edit" @click="editShowDialog(item)">修改</a>
                    <button class="del" @click="delAddress(item.id)">删除</button>
                  </div>
                  <div class="caozuo" v-else>
                     <button  class="el-button el-button--primary el-button--small" @click="checkAddress(item.id)">选择</button>
                     <a style="margin-left: 10px;" class="edit" @click="editShowDialog(item)">修改</a>
                    <button class="def">默认</button>
                  </div>
                </div>

              </template>

              <div v-else>正在加载中....</div>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>

            </span>
          </el-dialog>

          <el-dialog :visible.sync="dialogVisible1" class="dia-title" title="添加地址" width="40%">
            <el-form
              style="margin-top:10px"
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
            <el-form-item label="自动识别">
              <el-input style="width:450px" v-model="autoAdd" placeholder="淘宝单号,文件名,手机,姓名"></el-input>
              <el-button style="margin-left:20px" type="success" @click="autoSpot">开始识别</el-button>
            </el-form-item>
              <el-form-item label="收货人姓名" prop="shopping_name">
                <el-input v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="shopping_phone">
                <el-input v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
              </el-form-item>
              <el-form-item label="分机号" prop="ext_number">
                <el-input v-model="ruleForm.ext_number" placeholder="请输入分机号"></el-input>
              </el-form-item>
              <v-distpicker  class="address_picker" style="margin:0 0 10px 100px" @selected="onSelected"></v-distpicker>
              <el-form-item label="详细地址" prop="query">
                <el-input v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible1 = false">取 消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm')" class="diz">添加地址</el-button>
            </span>
          </el-dialog>

          <!--  -->
          <el-dialog
          title="银联扫码支付"
          :visible.sync="zxpayVisible"
           :showClose="false"
           :close-on-click-modal="false"
           width="30%">
            <div  style="margin: 0 auto;text-align: center;" >
              <template>
                <div style="margin: 0 auto;">
                 <img  :src="zxpayimg" width="250px" height="250px">

                  </div>
<div>
  <span>请用支付宝,微信,云闪印扫描支付</span>
</div>

              </template>

            </div>

            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="zxzhifu()">已支付</el-button>
              <el-button @click="goorder()">重新支付</el-button>

            </span>
          </el-dialog>
        </div>
      </div>
      <div id="pay-methods">
        <div class="sy-tit">
          <strong>支付方式</strong>
        </div>
        <div class="methods">
          <ul class="clearfix method-box">
            <li class="current" id="1">
              <a href="javascript:void(0);" class="balanceBox">
                <span class="balanceInfo">
                  余额:
                  <i>{{yue+'元'}}</i>
                </span>
                <img src="../assets/order/balance.png" alt="余额支付" />
                <span class="factory_discount" v-if="zhifu_discount_arr[0]>0 && zhifu_discount_arr[0] < 100">{{zhifu_discount_arr[0]}}折</span>
              </a>
            </li>
            <li id="2" v-if="AliPay">
              <a href="javascript:void(0);">
                <img src="../assets/order/Alipay.png" alt="支付宝支付" />
                <span class="factory_discount" v-if="zhifu_discount_arr[1]>0 && zhifu_discount_arr[1] < 100">{{zhifu_discount_arr[1]}}折</span>
              </a>
            </li>
            <li id="3" v-if="WeChatPay">
              <a href="javascript:void(0);">
                <img src="../assets/order/weChat.png" alt="微信支付" />
                <span class="factory_discount" v-if="zhifu_discount_arr[2]>0 && zhifu_discount_arr[2] < 100">{{zhifu_discount_arr[2]}}折</span>
              </a>
            </li>
            <li id="4" v-if="ZxPay">
              <a href="javascript:void(0);">
                <img src="../assets/order/ZxPay.png" alt="银联支付" />
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div id="summary" class="clearfix">
        <div class="statistic">

          <div class="list">
            <span>
              <i class="co-red" style="font-size:16px; font-weight:bold">{{orderCount}}</i> 个订单，总应付金额:
            </span>
            <i class="co-red" style="font-size:20px;">￥{{totalPrice1.toFixed(2)}}元</i>
          </div>
          <div class="list">
            <span>其中包含运费：</span>
            <i class="co-red" style="font-size:20px;">￥{{totalCost1.toFixed(2)}}元</i>
          </div>
          <div class="list" v-if="product_discount_price > 0">
            <span style="color: red;">商品折扣优惠：</span>
            <i class="co-red" style="font-size:20px;">-￥{{product_discount_price}}元</i>
          </div>
          <div class="list" v-if="zhifu_discount_price > 0">
            <span style="color: red;">支付折扣优惠：</span>
            <i class="co-red" style="font-size:20px;">-￥{{zhifu_discount_price}}元</i>
          </div>
        </div>
      </div>
      <div id="foot" class="clearfix">
        <div class="SY clearfix">
          <div class="priceInfo">
            <div class="price">
              <span>应付金额：</span>
              <strong class="co-red" style="font-size:34px;">￥{{countPrice.toFixed(2)}}元</strong>
            </div>
            <!-- <div class="userInfo">
              <span>寄送至：师大的哈市的接口撒谎的框架爱上的框架爱售点卡坚实的哈市框架萨的还框架萨的还</span>
            </div>-->
          </div>
        </div>
      </div>
      <div id="sticky-wrap" class="clearfix">
        <button  class="paymentOrder">提交订单</button>
      </div>
    </div>
    <Fotter></Fotter>
  </div>
</template>

<script>
import Fotter from '../components/index/fotter'
import VDistpicker from 'v-distpicker'

export default {
  components: {
    Fotter,
    VDistpicker
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      zxpayVisible: false,
      zxpayimg: '',
      zhifuMethod: 1,
       autoAdd: '',
       soaddress: '',
      ruleForm: {
        // 省id
        provice_id: '',
        // 省市区id
        address: [],
        // 详细地址信息
        query: '',
        // 名字
        shopping_name: '',
		ext_number: '',
        // 手机号码
        shopping_phone: '',
        token: window.localStorage.getItem('token'),
        id: ''
      },
      AddressList: [],
      rules: {
        shopping_name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        shopping_phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请核对手机号码', trigger: 'blur' }
        ],
        query: [
          { required: true, message: '请输入配送地址', trigger: 'blur' },
          {
            min: 5,
            max: 120,
            message: '详细地址长度需要在5-120个汉字或字符之间',
            trigger: 'blur'
          }
        ]
      },
      orderList: [],
      token: '',
      expressList: [],
      // 订单数
      orderCount: 0,
      // 总运费
      totalCost: 0,
      totalPrice: 0,
      totalCost1: 0,
      totalPrice1: 0,
      factory_discount: [], // 厂家折扣数组
      zhifu_discount_arr: [100, 100, 100], // 支付折扣数组
      zhifu_discount_bili: 100, // 支付折扣比例
      zhifu_discount_price: 0, // 支付折扣金额

       product_discount_arr: [], // 产品折扣数组
       product_discount_bili: 100, // 产品折扣比例
       product_discount_price: 0, // 产品折扣金额

      // 拆包荷包
      key: [],
      // 数据重量
      w: [],
      // 数据价格
      p: [],
      f: 0,
      t: [],
      discount_fee: [],
      flag: 0,
      // 默认选中的地址id
      currentId: '',
      // 订单id
      orderId: '',
      // 快递id
      addressID: '',
      // 余额
      yue: '',
      logoUlr: '',
      // 购物车id
      carid: '',
      WeChatPay: false,
      AliPay: false,
      ZxPay: false
    }
  },
  computed: {
    countPrice() {
      return this.totalPrice1 - this.zhifu_discount_price - this.product_discount_price
    }
  },
  created() {
    let sy_info = window.sessionStorage.getItem('sy_info')

    this.logoUlr = JSON.parse(sy_info).logo
    if (!window.localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.token = window.localStorage.getItem('token')
    this.getYue()

   // this.queryEDList()
    this.queryPayMethods()
  },
  mounted() {
    const that = this
    $('.methods .method-box').on('click', 'li', function() {
      $(this)
        .addClass('current')
        .siblings('li')
        .removeClass('current')
      that.zhifuMethod = $(this).attr('id')
      console.log(that.zhifuMethod)
      that.zhifu_discount_bili = that.zhifu_discount_arr[that.zhifuMethod - 1]
      that.product_discount_arr = that.factory_discount[that.zhifuMethod - 1]
      // that.zhifu_discount_price = (parseFloat(that.totalPrice1 - that.totalCost1) * (100 - that.zhifu_discount_bili) / 100).toFixed(2)
      that.queryOrderList()
    })

   $(document).unbind('click').on('click', '.paymentOrder', function() {
      $(this).css('background', '#999')
      // $(this).removeClass('paymentOrder');
      that.paymentOrder()
   })
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      this.yue = res.data.money
      this.factory_discount = res.data.factory_discount
      this.zhifu_discount_arr = [
        this.factory_discount[0][0],
        this.factory_discount[1][0],
        this.factory_discount[2][0]
      ]
      this.zhifu_discount_bili = this.zhifu_discount_arr[0]
      this.product_discount_arr = this.factory_discount[0]
     this.queryOrderList()
    },
    // 验证信息填写是否完全
    submitForm(formName) {
      if (this.ruleForm.address.length < 3) {
        this.$message('请选择完整的省市区', 'error')
        return false
      }
      for (let i = 0; i < this.ruleForm.address.length; i++) {
        if (!this.ruleForm.address[i]) {
          this.$message('请选择完整的省市区', 'error')
          return false
        }
      }
       let address = this.ruleForm.address
      this.$refs[formName].validate(async valid => {
        if (!valid) {
          return false
        } else {
          if (!this.ruleForm.provice_id || !address) {
            this.$message('请选择详细地区信息', '提示')
            return false
          }

          this.ruleForm.address = address
          let param = new URLSearchParams()
          for (let key in this.ruleForm) {
            param.append(key, this.ruleForm[key])
          }

          // 添加地址
          if (this.flag == 0) {
            const { data: res } = await this.$http({
              method: 'post',
              url: 'api/address/addaddress',
              data: param
            })
            if (res.code == 1) {
              this.$confirm('添加地址信息成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            } else {
              this.$message.error('添加地址失败')
            }
          } else if (this.flag == 1) {
            const { data: resu } = await this.$http({
              method: 'post',
              url: 'api/address/editaddress',
              data: param
            })
            if (resu.code == 1) {
              this.$message.success('修改地址成功！', '提示')
              this.queryAddress()
              this.dialogVisible1 = false
              this.$refs[formName].resetFields()
              this.ruleForm.address = this.ruleForm.address.split(',')
            }
          }
        }
      })
    },
    onSelected(data) {
      this.ruleForm.address = []
      this.ruleForm.provice_id = ''
      this.ruleForm.provice_id = data.province.code
      for (let key in data) {
        this.ruleForm.address.push(data[key].code)
      }

      // console.log(this.ruleForm)
    },
    showDialog(id, orderId, e) {
      // 地址快递的id
      this.addressID = $(e.currentTarget)
        .parents('tbody')
        .children('.one')
        .find('.kuaidiSelect')
        .val()
      this.dialogVisible = true
      this.flag = 0
      this.currentId = id
      this.orderId = orderId
      // console.log(id) 地址id
      // console.log(orderId) 订单id
      this.queryAddress()

      // dom更新完成添加点击事件
      this.$nextTick(() => {
        $('#addressBox').on('click', '.address-item', function() {
          $(this)
            .addClass('active')
            .siblings('.address-item')
            .removeClass('active')
        })
      })
    },
    // 删除购物车内订单
    async delShopCar(id, del = 0) {
      let param = new URLSearchParams()
      param.append('ids', id)
      param.append('del', del)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/delcar',
        data: param
      })
      if (res.code == 1) {
        this.key = []
        this.queryOrderList()
      }
      if (res.code == 100) {
        this.$confirmm('此订单已经合拼,会同时删除合拼订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          this.delShopCar(id, 1)
        })
      }
    },
    // 切换快递方式
    async addressChange(e, orderId, addressId) {
      // 快递方式id
      let express_id = $(e.currentTarget).val()
      let param = new URLSearchParams()
      param.append('id', orderId)
      param.append('express_id', express_id)
      param.append('address_id', addressId)

      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/editcaraddress',
        data: param
      })
      // console.log(res)
      // this.queryEDList()
      if (res.code == 1) {
        this.queryOrderList()
        } else {
          $('#express' + orderId).val(res.data.old_express_id)
          this.$confirm(res.msg, '提示')
        }
    },
    // 添加地址
    addaddress() {
      this.flag = 0
      this.dialogVisible1 = true
      $('.diz span').text('添加地址')
    },
    // 切换地址
    async checkAddress(id) {
      let address_id = id
      if (address_id == '') {
        this.$confirm('请选择收货地址')
        return
      }
      let param = new URLSearchParams()
      param.append('id', this.orderId)
      param.append('express_id', this.addressID)
      param.append('address_id', address_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/editcaraddress',
        data: param
      })
      if (res.code == 1) {
        this.$confirm('修改收货地址成功', '提示')
        this.queryOrderList()
        this.dialogVisible = false
      }
    },
    // 点击编辑
    editShowDialog(data) {
      this.ruleForm.shopping_name = data.shopping_name
      this.ruleForm.shopping_phone = data.shopping_phone
      this.ruleForm.ext_number = data.ext_number
      this.ruleForm.query = data.query
      this.ruleForm.id = data.id
      this.dialogVisible1 = true
      this.flag = 1
      $('.diz span').text('修改地址')
    },
    // 设置默认地址
    async settingAddress(id) {
      let param = new URLSearchParams()
      param.append('id', id)
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/address/defaddress',
        data: param
      })
      if (res.code == 1) {
        this.$message.success('设置成功')
        this.queryAddress()
      }
    },
    // 删除地址
    delAddress(id) {
      this.$confirmm('此操作将永久删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let param = new URLSearchParams()
          param.append('id', id)
          const { data: res } = await this.$http({
            method: 'post',
            url: '/api/address/deladdress',
            data: param
          })
          // console.log(res)
          if (res.code == 1) {
            this.$confirm('删除成功', '提示')
          }
          this.queryAddress()
        })
        .catch(() => {})
    },
    // 递归排序
    compare(property) {
      return function(a, b) {
        return b[property] - a[property]
      }
    },
    // 查询地址列表
    async queryAddress(id = '', linmt = 100) {
      let token = window.localStorage.getItem('token')
      if (token) {
        let param = new URLSearchParams()
        param.append('token', token)
        param.append('linmt', linmt)
        const { data: res } = await this.$http({
          method: 'post',
          url: '/api/address/index',
          data: param
        })
        if (res.code == 1) {
          this.AddressList = res.data.sort(this.compare('def'))
        } else {
          this.AddressList = []
        }
      }
    },

    goIndex() {
      this.$router.push('/index')
    },
    goorder() {
      this.$router.push('/order')
    },
    zxzhifu() {
      this.$message('未完成支付!', 'error')
    },
    // 查询订单
    async queryOrderList() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      if (window.sessionStorage.getItem('cartype')) {
        if (window.sessionStorage.getItem('cartype') == 2) {
          param.append('cartype', 2)
        } else if (window.sessionStorage.getItem('cartype') == 4) {
          param.append('cartype', 4)
        } else {
          param.append('cartype', 3)
        }
      } else {
        param.append('cartype', 1)
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/car/detail',
        data: param
      })

      let data = res.data
      let yunfei = 0
      let xiaoji = 0

      let ids = []
      let k = []
      let w = []

      if (this.key.length != 0) {
        this.key = this.key.split(',')
      }
      if (res.code == 1) {
        this.p = []
        this.totalCost = 0
        this.totalPrice = 0
        this.totalCost1 = 0
        this.totalPrice1 = 0
        this.product_discount_price = 0
        this.zhifu_discount_price = 0
        for (let key in data) {
          yunfei = 0
          xiaoji = 0

          let k = []
          let t = []

          if (data[key].length > 1) {
            for (let j in data[key]) {
              k.push(data[key][j].k)
              ids.push(data[key][j].id)
              this.totalPrice += parseFloat(data[key][j].total_price)
              this.totalPrice += parseFloat(data[key][j].packprice)

              this.totalPrice1 += parseFloat(data[key][j].total_price)
              this.totalPrice1 += parseFloat(data[key][j].packprice)

              this.product_discount_bili = this.product_discount_arr[data[key][j].product_id]
              this.product_discount_price += (parseFloat(data[key][j].total_price) + parseFloat(data[key][j].packprice)) * (100 - this.product_discount_bili) / 100

              xiaoji += data[key][j].total_price

              xiaoji += parseFloat(data[key][j].packprice)
              if (this.f == 0) {
                this.w.push(data[key][j].total_weight)
              }
                this.p.push(data[key][j].total_ship_price)
            }

            data[key].k = k.join(',')

            data[key].ids = ids.join(',')
            if (this.key.length < data.length) {
              this.key.push(data[key].k)
            }

            yunfei = data[key][0].total_ship_price

            data[key].yunfei = parseFloat(yunfei)
            data[key].xiaoji = xiaoji + parseFloat(data[key][0].realy_ship_price)

            this.totalPrice += data[key].yunfei
            this.totalCost += data[key].yunfei
            this.totalPrice1 += data[key][0].realy_ship_price
            this.totalCost1 += data[key][0].realy_ship_price
          }

          if (this.f == 0) {
            if (data[key].length <= 1) {
              this.key.push(data[key][0].k)
              this.w.push(data[key][0].total_weight)
            }
          }

          if (data[key].length <= 1) {
              this.p.push(data[key][0].total_ship_price)
            }
              // xiaoji += parseFloat(data[key][j].packprice)

          // 计算总得价格
          if (data[key].length <= 1) {
            ids.push(data[key][0].id)
            this.totalPrice +=
              data[key][0].total_price +
              parseFloat(data[key][0].total_ship_price) +
              parseFloat(data[key][0].packprice)
            this.totalCost += parseFloat(data[key][0].total_ship_price)

            this.totalPrice1 +=
              data[key][0].total_price +
              parseFloat(data[key][0].packprice)

              this.product_discount_bili = this.product_discount_arr[data[key][0].product_id]
              console.log('12',this.totalPrice1);

              this.product_discount_price += (data[key][0].total_price + parseFloat(data[key][0].packprice)) * (100 - this.product_discount_bili) / 100
              this.totalPrice1 += parseFloat(data[key][0].realy_ship_price)

            this.totalCost1 += parseFloat(data[key][0].realy_ship_price)
          }
        }

        this.key = this.key.join(',')
        this.orderCount = data.length
        this.orderList = data
        console.log('--------------------------------------------------------------------------')
        this.t = []
        this.discount_fee = []

        for (let kkk in this.orderList) {
          if (this.orderList[kkk].length > 1) {
            for (let i = 0; i < this.orderList[kkk].length; i++) {
              this.t.push(this.orderList[kkk].xiaoji) +
              parseFloat(this.orderList[kkk][0].packprice)
              this.product_discount_bili = this.product_discount_arr[this.orderList[kkk][0].product_id]
              var product = (this.orderList[kkk].xiaoji + parseFloat(this.orderList[kkk][0].packprice) - this.orderList[kkk][0].realy_ship_price) * (100 - this.product_discount_bili) / 100
              var zhifu = (this.orderList[kkk].xiaoji + parseFloat(this.orderList[kkk][0].packprice) - this.orderList[kkk][0].realy_ship_price - product) * (100 - this.zhifu_discount_bili) / 100

              this.discount_fee.push(parseFloat(product) + parseFloat(zhifu))
            }
          } else {
            this.t.push(
              parseFloat(this.orderList[kkk][0].realy_ship_price) +
                parseFloat(this.orderList[kkk][0].total_price) +
                 parseFloat(this.orderList[kkk][0].packprice)
            )
             this.product_discount_bili = this.product_discount_arr[this.orderList[kkk][0].product_id]
             var product = (parseFloat(this.orderList[kkk][0].total_price) + parseFloat(this.orderList[kkk][0].packprice)) * (100 - this.product_discount_bili) / 100
             var zhifu = (parseFloat(this.orderList[kkk][0].total_price) + parseFloat(this.orderList[kkk][0].packprice) - product) * (100 - this.zhifu_discount_bili) / 100
console.log(this.product_discount_bili, product, zhifu)
            this.discount_fee.push(parseFloat(product) + parseFloat(zhifu))
          }
        }
        this.f++

        // console.log(this.key)
        // // console.log(this.w.join(','))
        // console.log(this.p.join(','))
        // console.log(this.t.join(','))
        // console.log(data)
        // console.log(this.t)

        // console.log(this.orderCount)
        // console.log(this.totalCost, this.totalCost1)
        // console.log(this.totalPrice, this.totalPrice1)

        this.zhifu_discount_price = (parseFloat(this.totalPrice1 - this.totalCost1 - this.product_discount_price) * (100 - this.zhifu_discount_bili) / 100).toFixed(2)

         // this.countPrice = parseFloat(this.countPrice - this.discount_price).toFixed(2)
      } else {
        this.$router.go(-1)
      }

      this.carid = ids.join(',')
    },
    // 自动识别
    async autoSpot() {
      const {
        data: res
      } = await this.$http.get(
        '/api/index/strtoaddress?str=' + this.autoAdd + '&token=' + window.localStorage.getItem('token')
      )
      if (res.code) {
        this.ruleForm.provice_id = res.data.province_id
        this.ruleForm.query = res.data.detail
        this.ruleForm.shopping_phone = res.data.mobile
        this.ruleForm.shopping_name = res.data.name
        this.ruleForm.ext_number = res.data.ext_number
        this.ruleForm.address =
          res.data.province_id +
          ',' +
          res.data.city_id +
          ',' +
          res.data.county_id
        $('.address_picker select:first option:first').text(
          res.data.province_name
        )
        // this.selectProductInfo.data.region_id = res.data.province_id
        $('.address_picker select:eq(1) option:first').text(res.data.city_name)
        $('.address_picker select:last option:first').text(res.data.county_name)
        $('.address_picker select:first option:first')
      }
    },
    async autoaddress() {
        $('#addressBox>div').hide()
        $("#addressBox>div:contains('" + this.soaddress + "')").show()
    },

    // 快递
    async queryEDList() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http.post('api/car/expresslst', param)
      if (res.code == 1) {
        this.expressList = res.data
      } else {
        this.$confirm('获取地址信息失败,请刷新页面重试', '提示')
      }
    },
    // 查询中心订单是否支付了
    async zxqueryOrder(order_pid) {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('order_pid', order_pid)
      const { data: res } = await this.$http.post('api/pays/zxqueryOrder', param)
      if (res.code == 1) {
        this.zxpayVisible = false
       this.$router.replace('/order')
      } else {
        setTimeout(() => {
           this.zxqueryOrder(order_pid)
        }, 1000)
      }
    },
    // 支付
    async paymentOrder() {
      let param = new URLSearchParams()
      param.append('token', this.token)
      param.append('amount', this.countPrice.toFixed(2))
      param.append('payway', this.zhifuMethod)
      param.append('key', this.key)
      param.append('weight', this.w.join(','))
      param.append('price', this.p.join(','))
      param.append('total_price', this.t.join(','))
      param.append('discount_fee', this.discount_fee.join(','))
      param.append('carid', this.carid)
      if (window.sessionStorage.getItem('cartype')) {
        if (window.sessionStorage.getItem('cartype') == 2) {
          param.append('cartype', 2)
        } else if (window.sessionStorage.getItem('cartype') == 4) {
          param.append('cartype', 4)
        } else {
          param.append('cartype', 3)
        }
      } else {
        param.append('cartype', 1)
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/order/addorder',
        data: param
      })
      // if (res.data.payway == '4') {
      //   this.$confirmm('扫描新页面二维码支付,支付成功点击确定,支付失败点击重新支付', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '重新支付',
      //     type: 'warning'
      //   })
      //   .then(() => {
      //     window.history.go(0)
      //   })
      //   .catch(() => {
      //     window.history.go(0)
      //   })
      //   window.location.href = "/pay/order.html";
      //   return false;
      //  }
      if (res.code == 1) {
        let params = new URLSearchParams()
        params.append('amount', res.data.amount)
        params.append('order_pid', res.data.order_pid)
        params.append('payway', res.data.payway)
        params.append('token', window.localStorage.getItem('token'))
        const { data: result } = await this.$http({
          method: 'post',
          url: 'api/pays/submit',
          data: params
        })
        if (res.data.payway == '1') {
          if (res.code == 1) {
            this.$confirm({
              title: '提示',
              type: 'success',
              message: `支付成功,点击确定查看订单`,
              showClose: false,
              closeOnClickModal: false,
              callback: res => {
                if (res == 'confirm') {
                  this.$router.replace('/order')
                } else {
                  this.$router.replace('/detail')
                }
              }
            })
          } else {
            this.$confirm(res.msg, '提示')
          }
          return
        } else if (res.data.payway == '4') {
           this.zxpayVisible = true
           this.zxpayimg = result.data
           this.zxqueryOrder(res.data.order_pid)
           return
        }
        const div = document.createElement('div')
        div.innerHTML = result // html code
        document.body.appendChild(div)
        document.forms.alipaysubmit.submit()
      } else if (res.code == 0) {
          if (res.msg == '余额不足') {
              this.$confirmm('余额不足，请充值', '提示', {
                confirmButtonText: '去充值',
                cancelButtonText: '取消',
                type: 'warning'
              })
              .then(() => {
                this.$router.push('/recharge')
              })
              .catch(() => {})
          } else {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '立即刷新',
              cancelButtonText: '确定',
              type: 'warning'
            })
              .then(() => {
                window.history.go(0)
              })
              .catch(() => {
                window.history.go(0)
              })
          }
      }
    },

    // 支付方式
    async queryPayMethods() {
      const { data: res } = await this.$http.get('api/index/payway')
      this.WeChatPay = res.data[3]
      this.AliPay = res.data[2]
      this.ZxPay = res.data[4]
    }
  },
  destroyed() {
    window.sessionStorage.removeItem('cartype')
  }
}
</script>

<style lang="less" scoped>
.sy_logo {
  width: 120px;
}
.header {
  width: 100%;
  height: 110px;
  background-color: #fff;
  margin-bottom: 30px;
  .w {
    line-height: 110px;
    .logo {
      cursor: pointer;
      float: left;
      line-height: 110px;
    }
    .msg {
      float: left;
      margin: 50px 0 30px 25px;
      width: 170px;
      height: 25px;
      border-left: 2px solid #999;
      line-height: 25px;
      text-align: center;
      color: #a77c5a;
      font-size: 22px;
    }
  }
}
strong {
  font-size: 14px;
  color: #333;
}
.co-red {
  color: #e83030 !important;
}
#content {
  background-color: #fff;
  padding: 20px;
  .checkout-steps {
    margin-bottom: 25px;
    .w {
      .orderInfo {
        display: block;
        font-size: 14px;
        color: #333;
        margin-bottom: 15px;
      }
      table {
        th {
          background-color: #fafafa;
          border: 1px solid #eee;
          height: 38px;
          line-height: 38px;
          text-align: center;
        }
        tr {
          border: 1px solid #eee;
        }
        td {
          font-size: 12px;
          color: #666666;
          border: 1px solid #eee;
          text-align: center;
          padding: 10px;
          .addressSettings {
            float: right;
            font-size: 12px;
            color: #a77c5a;
            padding: 2px 5px;
            background: #edfff6;
          }
          .delete {
            background-color: #bfbfbf;
          }
          .Chai {
            background-color: #a77c5a;
            margin-bottom: 10px;
          }
        }
        .address {
          text-align: left;
        }
      }
    }
  }
  .order-summary {
    margin-bottom: 30px;
    height: 95px;
    .tit {
      margin-bottom: 18px;
      strong {
        font-size: 14px;
        color: #333;
      }
      i {
        color: #999;
        font-size: 12px;
      }
    }
    .sy-item {
      margin-bottom: 8px;
      span {
        font-size: 12px;
        color: #666;
      }
      a {
        margin-left: 20px;
        color: #a77c5a;
      }
    }
  }
  .current {
    background: url('../assets/order/duigou.png') no-repeat right bottom;
  }
  .active {
    background-color: #d9e9d5;
  }
  #Virtualdiv {
    margin-bottom: 20px;
    .sy-panel-main {
      margin-top: 10px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      color: #666;
      select {
        height: 30px;
        width: 150px;
        margin: 0 10px;
      }
    }
  }
  #pay-methods {
    .methods {
      margin-top: 12px;
      .method-box {
        .balanceBox {
          position: relative;
        }
        .balanceInfo {
          position: absolute;
          right: 25px;
          top: 24px;
        }
        .factory_discount{
          position: absolute;
          right: 2px;
          top: -20px;
          font-size: 16px;
          color: red;
        }
        li {
          position: relative;
          float: left;
          width: 180px;
          height: 72px;
          margin-right: 20px;
          a {
            display: block;
            height: 100%;
            line-height: 72px;
            box-shadow: 1px 1px 6px 2px #eee;
            text-align: center;
          }
          a:hover {
            border: 1px solid #a77c5a;
          }
        }
      }
    }
  }
  #summary {
    padding: 30px 15px;
    .statistic {
      float: right;
      .list {
        text-align: right;
        margin-bottom: 8px;
        font-size: 12px;
        color: #666;
      }
    }
  }
  #foot {
    padding: 15px;
    background-color: #f2f2f2;
    .SY {
      float: right;
      width: 590px;
      .price {
        float: right;
        margin-bottom: 10px;
      }
      .userInfo {
        float: right;
      }
    }
  }
  #sticky-wrap {
    padding: 40px;
    button {
      float: right;
      width: 120px;
      height: 40px;
      line-height: 40px;
      background-color: #a77c5a;
      color: #fff;
      font-size: 16px;
    }
  }
  #addressBox {
    margin-top: 10px;
    .address-item {
      cursor: pointer;
      margin-bottom: 10px;
      margin-bottom: 10px;
      .un {
        float: left;
        width: 80px;
        height: 30px;
        background-color: #a77c5a;
        border: 1px solid #a77c5a;
        font-size: 12px;
        color: #fff;
        margin-right: 10px;
      }
      p {
        float: left;
        line-height: 30px;
      }
      .address1 {
        margin-left: 5px;
        max-width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .Addressquery {
        margin: 0 5px;
        max-width: 350px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .caozuo {
        width: 200px;
        float: right;
        font-size: 12px;
        line-height: 30px;
        .set {
          color: #4da5ff;
          cursor: pointer;
        }
        .edit {
          color: #a77c5a;
          margin-left: 8px;
          cursor: pointer;
        }
        .del {
          background: #fff;
          margin-left: 8px;
        }
        .def {
          color: #fff;
          background-color: #bfbfbf;
          padding: 2px 5px;
        }
      }
    }
  }
}
select {
  height: 30px;
  width: 90px;
}
</style>
